import { App } from 'hydra-data-types';

function getLocalHostProductPath(): App {
  const pathName = window.location.pathname;
  if (pathName.includes('nerva')) {
    return App.Nerva;
  } else if (pathName.includes('meno')) {
    return App.Meno;
  } else if (pathName.includes('quit')) {
    return App.Quit;
  } else if (pathName.includes('pain')) {
    return App.Pain;
  }
  return App.Nerva; // for cypress tests
}

const HOSTNAME_TO_APP: Record<string, App> = {
  'assessment.nervaibs.com': App.Nerva, // prod
  'assessment.mindsethealth.com': App.Nerva, // prod
  'assessment.evia.app': App.Meno, // prod
  'assessment.tryfinito.com': App.Quit, // prod
  'assessment.reliohealth.com': App.Pain, // prod

  'beta-nerva.firebaseapp.com': App.Nerva, // staging
  'beta-nerva.web.app': App.Nerva, // staging
  'beta-evia.firebaseapp.com': App.Meno, // staging
  'beta-evia.web.app': App.Meno, // staging
  'beta-quit.firebaseapp.com': App.Quit, // staging
  'beta-quit.web.app': App.Quit, // staging
  'beta-pain.firebaseapp.com': App.Pain, // staging
  'beta-pain.web.app': App.Pain, // staging

  'nerva-dev.firebaseapp.com': App.Nerva, // dev
  'nerva-dev.web.app': App.Nerva, // dev
  'evia-dev-ba055.firebaseapp.com': App.Meno, // dev
  'evia-dev-ba055.web.app': App.Meno, // dev
  'quit-dev.firebaseapp.com': App.Quit, // dev
  'quit-dev.web.app': App.Quit, // dev
  'pain-dev-c18ff.firebaseapp.com': App.Pain, // dev
  'pain-dev-c18ff.web.app': App.Pain, //dev

  localhost: getLocalHostProductPath(), // local dev
};

const APP = HOSTNAME_TO_APP[window.location.hostname];
const VERSION = process.env.REACT_APP_VERSION ?? 'unknown';
const PRODUCTION =
  process.env.NODE_ENV === 'production' && process.env.REACT_APP_DEPLOY_ENV === 'production';
const STAGING =
  process.env.NODE_ENV === 'production' && process.env.REACT_APP_DEPLOY_ENV === 'staging';
const DEVELOPMENT = !PRODUCTION && !STAGING;
const E2E_TESTING = 'Cypress' in globalThis.window;

type EnvironmentType = {
  APP: App;
  VERSION: string;
  PRODUCTION: boolean;
  STAGING: boolean;
  DEVELOPMENT: boolean;
  E2E_TESTING: boolean;
};

export const Environment: Readonly<EnvironmentType> = {
  APP,
  VERSION,
  PRODUCTION,
  STAGING,
  DEVELOPMENT,
  E2E_TESTING,
};

// Log version for use in production
if (!Environment.DEVELOPMENT) {
  console.log(`${Environment.APP} Web Assessment v${Environment.VERSION}`);
}
